import {Log} from '@aboutyou/mlm';
import {
  AvailableFeatureNames,
  FeatureToggleConfig,
  FeatureToggleOverrides,
} from './types';

const FEATURE_SEPARATOR = ',';
const VALUE_SEPARATOR = ':';

const booleanValues: Record<string, boolean> = {
  true: true,
  false: false,
};

export const FEATURE_FLAG_OVERRIDES_PARAM = 'feature-flag-overrides';

export const getUrlConfigFeatureFlagOverrides = (
  params: URLSearchParams,
): FeatureToggleOverrides => {
  const urlParameterValue = params.get(FEATURE_FLAG_OVERRIDES_PARAM) || '';

  const overrides = {} as FeatureToggleOverrides;

  try {
    for (const config of urlParameterValue.split(FEATURE_SEPARATOR)) {
      const [featureName, value] = config.split(VALUE_SEPARATOR);
      if (featureName && value) {
        // We want to convert 'true' and 'false' to boolean
        // ?? Operator is used here because we want to keep false
        overrides[featureName as AvailableFeatureNames] = {
          defaultValue: booleanValues[value] ?? encodeURIComponent(value),
        } as unknown as FeatureToggleConfig;
      }
    }
  } catch (error) {
    Log.warn(
      '@aboutyou/bootstrap',
      'Error reading feature-flag overrides from url',
      error,
    );
  }

  return overrides;
};
